import I18N from '@leverege/i18n';

/**
 * Creates an initializer for I18N
 */
export default {
  id: 'molten.I18NInit',
  sort: -100,
  init: async molten => {
    // Create the opts for i18n. 
    const options = {
      ...molten.getConfig('i18n', {})
    };
    await I18N.init(options);
  }
};